export const SAVED_BRIEF_READY_EVENT = 'saved-brief-ready';
export const SAVED_BRIEF_CREATED_EVENT = 'saved-brief-created';
